'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsBannerLoader = exports.CmsBannerLoaderUnwrapped = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _cms = require('helpers/cms');

var _decorator = require('helpers/decorator');

var _deep = require('helpers/deep');

var _verify = require('helpers/verify');

var _Sagas = require('decorators/Sagas/Sagas');

var _localStorage = require('redux/saga/helpers/local-storage');

var _bound = require('redux/saga/entities/bound');

var _Banners = require('./Banners.reducer');

var _CmsBannerLoader = require('./CmsBannerLoader.saga');

var _BannerHost = require('./BannerHost');

var _CmsBanner = require('./CmsBanner');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _BannerHost.registerBanner)('CmsAnnouncement', _CmsBanner.CmsBanner);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    banners: (0, _deep.deepExtract)('modules', _bound.cmsWebContent.data(state, 'banners')),
    path: state.request.path,
    shouldShowBanner: !(0, _Banners.selectHasBannersQueued)(state)
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  loadBanners: _CmsBannerLoader.loadCmsBanners,
  addBanner: _Banners.addAnnouncement
};

var CmsBannerLoaderUnwrapped = exports.CmsBannerLoaderUnwrapped = function (_Component) {
  (0, _inherits3.default)(CmsBannerLoaderUnwrapped, _Component);

  function CmsBannerLoaderUnwrapped(props) {
    (0, _classCallCheck3.default)(this, CmsBannerLoaderUnwrapped);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CmsBannerLoaderUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(CmsBannerLoaderUnwrapped)).call(this, props));

    _this.state = {
      pageMatchersByBannerName: {}
    };
    return _this;
  }

  (0, _createClass3.default)(CmsBannerLoaderUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadBanners();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.banners && nextProps.banners) {
        this.handleBannerDataLoaded(nextProps.banners);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var pageMatchersByBannerName = this.state.pageMatchersByBannerName;
      var _props = this.props,
          banners = _props.banners,
          path = _props.path,
          shouldShowBanner = _props.shouldShowBanner;


      if ((0, _verify.isEmpty)(banners) || !shouldShowBanner) {
        return;
      }

      var seenBanners = (0, _localStorage.readSessionStorage)('cmsBannersSeen', []);

      var candidateBanner = banners.filter(function (_ref) {
        var name = _ref.name;
        return pageMatchersByBannerName[name](path);
      }).filter(function (_ref2) {
        var name = _ref2.name;
        return !seenBanners.includes(name);
      }).shift();

      if (candidateBanner) {
        this.triggerBanner(candidateBanner);
        (0, _localStorage.writeSessionStorage)('cmsBannersSeen', [].concat((0, _toConsumableArray3.default)(seenBanners), [candidateBanner.name]));
      }
    }
  }, {
    key: 'handleBannerDataLoaded',
    value: function handleBannerDataLoaded(banners) {
      if (!banners) {
        return;
      }

      var pageMatchersByBannerName = banners.reduce(function (memo, banner) {
        memo[banner.name] = (0, _cms.createPageMatcher)(banner.pages);
        return memo;
      }, {});

      this.setState({ pageMatchersByBannerName: pageMatchersByBannerName });
    }
  }, {
    key: 'triggerBanner',
    value: function triggerBanner(bannerProps) {
      this.props.addBanner(bannerProps.name, 'CmsAnnouncement', bannerProps);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return CmsBannerLoaderUnwrapped;
}(_react.Component);

CmsBannerLoaderUnwrapped.propTypes = {
  addBanner: _propTypes2.default.func,
  banners: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string,
    pages: _propTypes2.default.arrayOf(_propTypes2.default.string),
    position: _propTypes2.default.oneOf(['top', 'bottom'])
  })),
  loadBanners: _propTypes2.default.func,
  path: _propTypes2.default.string,
  shouldShowBanner: _propTypes2.default.bool
};

var CmsBannerLoader = exports.CmsBannerLoader = (0, _decorator.decorateWith)((0, _Sagas.withSagas)({
  watch: _CmsBannerLoader.watchSaga
}), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(CmsBannerLoaderUnwrapped);